import { api } from "../.."

// função para aprovar rdi
const ApproversRDIApproveService = async (id: number, items: string) => {

    const response = await api.post(`approvers/rdi/approve/${id}`, {
        items
    });

    return response

}
// função para aprovar rdi

// função para reprovar rdi
const ApproversRDIReproveService = async (id: number, items: string) => {

    const response = await api.post(`approvers/rdi/reprove/${id}`, {
        items
    });

    return response

}
// função para reprovar rdi

export {
    ApproversRDIApproveService,
    ApproversRDIReproveService
}